module.exports = __webpack_public_path__ + "img/4-1.a4989d06.svg";